import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { PipeModule } from "app/pipes/pipe.module";
import {PhotoListSurveyFieldComponent} from "./photoListSurveyField.component";


@NgModule({
  declarations: [
    PhotoListSurveyFieldComponent
  ],
  exports: [
    PhotoListSurveyFieldComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    PipeModule
  ]
})
export class PhotoListSurveyFieldModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/components/photoListSurveyField/photoListSurvetField.module.ts